module.exports = __webpack_public_path__ + "e0106718/img/placeholder.888fcd0b.svg";